import {
  type Modifiable,
  useModificationsFilter,
} from '@carboncopyco/editor-ui';
import type { IDynamicEditData } from '@carboncopyco/types';
import { getEditLabel } from '../utils';

export const useSpotEditsFilters = ({
  spotEditsModifications,
  pageUrl,
}: {
  spotEditsModifications: IDynamicEditData[];
  pageUrl: string;
}) => {
  const modifications: Modifiable[] = spotEditsModifications.map((edit) => ({
    ...edit,
    content: {
      isGlobal: edit.isGlobal ?? false,
      url: edit.url,
      title: getEditLabel(edit),
    },
  }));

  const {
    result: filteredModifications,
    selectedFilter,
    onFiltersChange,
    searchValue,
    onSearchChange,
  } = useModificationsFilter({
    modifications,
    pageUrl,
  });

  return {
    result: filteredModifications as unknown as Record<
      string,
      IDynamicEditData[]
    >,
    selectedFilter,
    onFiltersChange,
    searchValue,
    onSearchChange,
  };
};
